<template>
  <v-card id="account-setting-card">
    <div id="contactList" style="padding: 30px">
      <h1>Contact List</h1>
      <v-btn class="ma-2" outlined color="teal" @click="tabeRe()"> <v-icon>mdi-flash</v-icon>Refresh </v-btn>
      <v-app id="inspire">
        <v-card>
          <v-card-title>
            Contact List
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :loading="!myitems.length"
            loading-text="Loading... Please wait"
            :headers="headers"
            :items="myitems"
            :search="search"
            sort-field="durations"
          ></v-data-table>
        </v-card>
      </v-app>
    </div>
  </v-card>
</template>
<style scoped>
</style>
<script>
import { doc, getDoc } from 'firebase/firestore'
import { dbRef, contactsClick } from '../../../../firebaseConfig'
import { getUID, getCurrentDeviceSelected } from '../../../../localStorage'
export default {
  name: 'contactList',
  data() {
    return {
      search: '',
      myitems: [],
      headers: [
        {
          text: 'Name',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        { text: 'DeviceID', value: 'deviceID' },
        { text: 'Number', value: 'number' },
        { text: 'Uid', value: 'uid' },
      ],
      desserts: [
        {
          deviceID: 'Frozen Yogurt',
          durations: 159,
          name: 6.0,
          carbs: 24,
          number: 4.0,
          time: '1%',
        },
      ],
    }
  },
  mounted: function () {
    contactsClick()
    this.getConstactList()
  },
  methods: {
    async getConstactList() {
      this.$store.commit('LOADER', true)
      let uid = getUID()
      const myDoc = doc(dbRef, 'contactList', uid, getCurrentDeviceSelected(), uid + '-' + getCurrentDeviceSelected())
      getDoc(myDoc)
        .then(res => {
          let listOfApps = res.data()
          console.log(listOfApps)
          Object.values(listOfApps).map(i => {
            this.myitems.push(i)
          })
        })
        .catch(error => {
          console.log(error)
        })
        .finally(res => {
          this.$store.commit('LOADER', false)
        })
    },
    async tabeRe() {
      // this.myD();
      // console.log("inside tablere");
      // var x = await this.myD();
      //  console.log(x);
      //  this.myitems = this.myitems.slice().reverse();
      //  let d=this.myD();
      // d.then(data=>console.log("then"+data));
      //this.myitems = this.myitems.reverse;
      //    this.myD().then(data=>{
      //        console.log("mydatw"+data);
      //    })
    },
  },
}
</script>